import { render, staticRenderFns } from "./galleryMobile.vue?vue&type=template&id=4125c28e&scoped=true"
import script from "./galleryMobile.vue?vue&type=script&lang=js"
export * from "./galleryMobile.vue?vue&type=script&lang=js"
import style0 from "./galleryMobile.vue?vue&type=style&index=0&id=4125c28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4125c28e",
  null
  
)

export default component.exports